import { useState } from "react";
import { MagnifyingGlassIcon } from "../../icons.js";
import type { WidgetProps } from "../types.js";
import { ClearableInput } from "../../ClearableInput.js";

export function SearchWidget({ onNavigate }: WidgetProps) {
  const [query, setQuery] = useState("");

  function submit(e: React.FormEvent) {
    e.preventDefault();
    const q = query.trim();
    if (!q) return;
    // Deep-link into the search page: the SearchPane reads `?q=` from the hash query.
    location.hash = `#/search?q=${encodeURIComponent(q)}`;
    onNavigate("search");
  }

  return (
    <section className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
      <div className="mb-2 flex items-center gap-2">
        <MagnifyingGlassIcon size={16} className="text-(--accent)" />
        <h2 className="font-semibold text-gray-900 dark:text-gray-100">Search</h2>
      </div>
      <form onSubmit={submit} className="flex gap-2">
        <ClearableInput
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search your records…"
          className="min-w-0 flex-1 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 py-1.5 text-sm text-gray-900 dark:text-gray-100 placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-(--accent)"
        />
        <button
          type="submit"
          className="rounded-lg bg-(--accent) px-3 py-1.5 text-sm font-medium text-(--accent-contrast) hover:bg-(--accent-hover)"
        >
          Search
        </button>
      </form>
    </section>
  );
}
